// removed by extract-text-webpack-plugin
module.exports = {"link":"_3eI3pKcM4JA-2nRnz4ESth","orange":"SNT8wOcrcDn2ECeTy5A38","gray":"_2bvnGxpbsVc9Aj_NHATpNM"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Link/style.css
// module id = 239
// module chunks = 37